<template>
  <li class="kds-verdict-row" :class="`kds-verdict-row--${tone}`">
    <span class="kds-verdict-row__dot" />
    <span class="kds-verdict-row__label">{{ labelByTone }}</span>
    <span class="kds-verdict-row__text">
      <slot>{{ text }}</slot>
    </span>
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { KdsVerdictRowTone } from '@/kds/types';

interface Props {
  tone: KdsVerdictRowTone;
  text?: string;
}

const props = defineProps<Props>();

const labelByTone = computed(() => {
  switch (props.tone) {
    case 'insight':
      return 'INSIGHT';
    case 'friction':
      return 'FRICTION';
    case 'witness':
      return 'WITNESS';
    default:
      return '';
  }
});
</script>

<style scoped lang="scss">
.kds-verdict-row {
  display: grid;
  grid-template-columns: 12px 80px 1fr;
  align-items: start;
  gap: var(--space-3);
  padding: var(--space-3) 0;
  border-bottom: var(--border);

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: var(--r-pill);
    margin-top: 6px;
  }

  &--insight .kds-verdict-row__dot {
    background: var(--info);
  }
  &--friction .kds-verdict-row__dot {
    background: var(--warn);
  }
  &--witness .kds-verdict-row__dot {
    background: var(--signal);
  }

  &__label {
    font-family: var(--font-mono);
    font-size: var(--fs-mono);
    letter-spacing: 0.08em;
    color: var(--stone);
    padding-top: 2px;
  }

  &__text {
    color: var(--ink);
    font-size: var(--fs-body);
    line-height: var(--lh-body);
  }
}
</style>
